import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withStyles } from '@material-ui/core/styles';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Typography from '@material-ui/core/Typography';
import Chip from '@material-ui/core/Chip';

import { fetchHeadersOfSessionFile } from '../../../api';

const styles = theme => ({
  select: {
    width: '100%',
    minHeight: '50px',
  },
  chips: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  chip: {
    margin: theme.spacing.unit / 4,
  },
});

class SelectJoinHeaderComponent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      headers: [],
    };
  }

  async componentDidMount() {
    if (this.props.fileId) {
      const headers = await fetchHeadersOfSessionFile(this.props.session.id, this.props.fileId);
      this.setState({ headers });
    }
  }

  renderHeaders() {
    return _.map(this.state.headers, (header, index) => (
      <MenuItem key={header + index} value={header}>
        <Typography>{header}</Typography>
      </MenuItem>
    ));
  }

  render() {
    const {
      name,
      onChange,
      session,
      fileId,
      value,
      classes,
    } = this.props;

    return (
      <FormControl fullWidth >
        <InputLabel htmlFor={`select-${fileId}`}>{session.files[fileId].filename}</InputLabel>
        <Select
          inputProps={{
            name,
          }}
          onChange={onChange}
          input={<Input id={`select-${fileId}`} />}
          value={value}
          className={classes.select}
          renderValue={selected => (
            <div className={classes.chips}>
              <Chip key={selected} label={selected} className={classes.chip} />
            </div>
          )}
        >
          {this.renderHeaders()}
        </Select>
      </FormControl>
    );
  }
}
SelectJoinHeaderComponent.propTypes = {
  name: PropTypes.string.isRequired,
  session: PropTypes.shape({
    id: PropTypes.string,
    createdAt: PropTypes.number,
    lastModified: PropTypes.number,
    name: PropTypes.string,
    files: PropTypes.shape({
      id: PropTypes.string,
      filename: PropTypes.string,
      lastModified: PropTypes.number,
      savedByUser: PropTypes.bool,
    }),
  }).isRequired,
  fileId: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

SelectJoinHeaderComponent.defaultProps = {
  value: '',
};

export default withStyles(styles)(SelectJoinHeaderComponent);
